import { Injectable } from '@angular/core';

@Injectable()

export class Config {
  public appId = '1e17ecbb-42ce-4d1a-a5f7-a66be84699ca';
  public appSlug = 'skinapb';

  public siteId = '33f91a67-bde5-4a4a-a58f-f2b7fb689ca5';

  public appName = 'Skina_Pub';
  public allowOpenTable = true;
  public allowPickup = true;
  public allowDelivery = true;

  // public apiUrl = 'http://localhost:8886/app';
  public apiUrl = 'https://api.foodplus.com.br/app';
  public siteUrl = 'https://site.foodplus.com.br/';
  public showLogo = true;

  public showSearchBar = true;

  public showVariationImage = true;

  public connected: boolean;
}

export const OneSignalAppId = '';
export const OneSignalSenderId = '';
